export const requirementsAidsdt = {
  requirementsAIDSDT: "Requirements AI-DS/DT",
  operationsName: "Operations Name",
  proccessDuration: "Proccess Duration (seconds)",
  numOfSteps: "Number of Steps",
  stepName: "Step Name",
  stepDuration: "Step Duration",
  requiredCycleTime: "Required Cycle Time",
  lineRunTime: "Line Run Time",
  costOfOpeningNewStation: "Cost of Opening New Station",
  unmetTaktPen: "Unmet Takt Penalty",
  minMTTR: "Minimum MTTR",
  maxMTBF: "Maximum MTBF",
  budget: "Budget",
  partsToBeProduced: "Parts to be Produced",
  operationalEfficiency: "Operational Efficiency",
  costSavings: "Cost Savings",
  oee: "OEE",
  amountOfMaterial: "Amount of Material",
  amountOfRawMaterial: "Amount of Raw Material",
  amountOfRecycledMaterial: "Amount of Recycled Material",
  amountOfCriticalMaterial: "Amount of Critical Material",
  amountOfWasteAtEndOfLife: "Amount of Waste at End of Life",
  gasEmission: "Gas Emission",
  co2Emission: "CO₂ Emission",
  amountProducedWastePerGeneration: "Amount of Produced Waste per Generation",
  amountHazardousWastePerGeneration: "Amount of Hazardous Waste per Generation",
  transportationOfProductionEquipment: "Transportation of Production Equipment",
  earningPerProduct: "Earning per Product",
  probabilityToAddAnOperationOrAModule:
    "Probability to Add an Operation or a Module",
  probabilityToRemoveAnOperationOrAModule:
    "Probability to Remove an Operation or a Module",
  numberOfResourceGroup: "Number of Resource Group",
  formalizedListOfAvailableWorkerSkillsInTheFactory:
    "Formalized List of Available Worker Skills in the Factory",
  minimumMTTR: "Minimum MTTR",
  maximumMTBF: "Maximum MTBF",
};
